import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { Dialog, Toast } from 'vant'
import qs from 'qs'
import {
  submitAnswer,
  getSubmitCount,
  changeCacheQuesStatus,
} from '@/api/index'
import { WebBridgeApi } from 'ijsbridge'
import { useSubmitBtnClick } from '@/hooks'
import { LOCAL_QUES_ANSWERS, LOCAL_QUES_ANSWERS_UUID } from '@/constants'
import { getQueryString, isInApp } from '@/utils/tools'

export const useCommonSubmitEffect = () => {
  const submitFlag = ref(false)
  const router = useRouter()
  const store = useStore()
  const questionActiveKey = getQueryString('questionActiveKey')
  const activeId = getQueryString('activeId')
  const unitId = getQueryString('unitId')
  const isPreview = getQueryString('isPreview')
    ? Number(getQueryString('isPreview'))
    : 0
  const isSetting = Number(getQueryString('isSetting'))
  const type = getQueryString('type')
  const isStudy = getQueryString('isStudy')
  const personAnswers = store.getters.getPersonAnswers

  const handleSubmitClick = async (answers, isSubmit, isRefresh) => {
    // 预览不提交
    if (isPreview || isSetting) {
      return
    }
    // 用来给倒计时判断是否已经提交过
    isSubmit && (isSubmit.value = true)
    // 防止多次点击
    if (submitFlag.value) {
      return
    }
    submitFlag.value = true
    const address = ref('')
    if (isInApp()) {
      if (store.getters.getOrgId === '33' || store.getters.getOrgId === '29') {
        const { err: checkErr, result: checkResult } =
          await WebBridgeApi.checkPermission({
            permission: 'location',
            title: '需要您打开定位权限',
          })
        if (checkResult) {
          const { err, result } = await WebBridgeApi.getCurrentPosition({
            type: 'gaode',
          })
          if (result) {
            address.value = result?.location?.address || result?.address
          }
        }
      }
    }

    const allAnswers = [...answers, ...personAnswers]

    console.log('answers', answers)

    // 处理填空题缓存
    handleFormatInputQues(allAnswers, store)



    // 去掉多选optionKey为空的情况，不然后台导出数据会报错
    allAnswers.forEach((item, index) => {
      if (item.questionType === 18) {
        if (item.answers[0] && !item.answers[0].optionKey) {
          allAnswers.splice(index, 1)
        }
      }
    })

    const submitTime = new Date()
    localStorage.setItem('submitTime', submitTime)

    const data = {
      questionActiveKey: questionActiveKey,
      answerJson: JSON.stringify(allAnswers),
      isPreview,
      longTime: submitTime - store.getters.getStartTime,
      token: store.getters.getToken,
      unitId: unitId,
      activeId: activeId,
      orgId: store.getters.getOrgId,
      location: address.value,
      // 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjQxNzg5NzEiLCJvcGVuaWQiOiI2Mlh3cWl4OW8wcFc0YTRtb0pGNFlBIiwib3JnaWQiOiIyOSIsIm5pY2tuYW1lIjoiXHU1ZjIwXHU1YjljXHU2MjEwIiwiYXZhdGFyIjoiaHR0cHM6XC9cL2ltZzExLmlxaWx1LmNvbVwvMjAyMFwvMDdcLzEzXC9lYTI2NzcwMDk2MDliYTdlNTNkYzE1MGVlZjQ0OTlmMy5wbmciLCJwbGF0Zm9ybSI6ImNodWFuZ3FpIn0.hJNTR9br_6kjX2FXUwO-mW0J1ysp6Iz9UjH2-eR4v0s'
    }
    let resultType = 1
    // 考试练习
    if (type === 'mock' || type === 'study' || isStudy) {
      data.isExercise = 2
      resultType = 2
    } else {
      resultType = 1
      data.isExercise = 1
    }



    // 试题学习不提交，直接跳结果页面
    if (isStudy != '') {
      router.replace(
        `/result?questionActiveKey=${questionActiveKey}&resultType=${resultType}&isStudy=${isStudy}`
      )

      return
    }

    // 埋点
    let btnName = ''
    if (type === 'mock') {
      btnName = '模拟考试'
    } else if (type === 'study') {
      btnName = '试题学习'
    } else {
      btnName = store.getters.getQuesInfo.type === '1' ? '' : '正式答题'
    }

    try {
      const res = await submitAnswer(qs.stringify(data))
      if (res.ok) {
       
        // 暂停收集情况
        if (res.ret === '2001') {
          Dialog({ message: '此系统已暂停收集，请等待再次开启后使用！' })

          submitFlag.value = false
          return null
        }
        // 选项限制
        if (res.ret === '2003') {
          Dialog({ message: res.comment })

          submitFlag.value = false
          return null
        }

        // 修改当前缓存的状态
        // changeCacheQuesStatus(qs.stringify({
        //   questionActiveKey: questionActiveKey,
        //   uuid: localStorage.getItem(LOCAL_QUES_ANSWERS_UUID),
        // }))

        // 提交成功清除缓存
        localStorage.removeItem(LOCAL_QUES_ANSWERS)
        localStorage.removeItem(LOCAL_QUES_ANSWERS_UUID)
        // 成功埋点
        useSubmitBtnClick({
          quesTitle: store.getters.getQuesInfo?.title,
          quesType: store.getters.getQuesInfo?.type,
          btnName
        })
        if (store.getters.getQuesInfo.type === 1) {
          // 继续填报，刷新当前页
          if (isRefresh === true) {
            Toast('提交成功，请继续填写')
            setTimeout(() => {
              location.reload()
            }, 500)
          } else {
            let routerUrl = `/ques-result?questionActiveKey=${questionActiveKey}&resultType=${resultType}&answerGroupKey=${res.dataMap?.answerGroupKey}`
            if (res.dataMap.orderSn) {
              routerUrl = `${routerUrl}&orderSn=${res.dataMap.orderSn}`
            }

            router.replace(routerUrl)
          }
        } else {
          router.replace(
            `/result?questionActiveKey=${questionActiveKey}&resultType=${resultType}&answerGroupKey=${res.dataMap?.answerGroupKey}&isStudy=${isStudy}`
          )
        }
      } else {
        if (Number(isPreview) === 1) {
          Dialog({ message: '测试提交成功，当前答案不记录' })
          router.replace(
            `/result?questionActiveKey=${questionActiveKey}&resultType=${resultType}&answerGroupKey=${res.dataMap?.answerGroupKey}&isStudy=${isStudy}`
          )
          return
        }
        // 失败埋点
        useSubmitBtnClick({
          quesTitle: store.getters.getQuesInfo?.title,
          quesType: store.getters.getQuesInfo?.type,
          btnName,
          status: res.comment
        })
        Dialog({ message: res.comment })
      }
    } catch (error) {
       // 失败埋点
       useSubmitBtnClick({
        quesTitle: store.getters.getQuesInfo?.title,
        quesType: store.getters.getQuesInfo?.type,
        btnName,
        status: error
      })
      submitFlag.value = false
    }
    submitFlag.value = false
  }

  return {
    submitFlag,
    handleSubmitClick,
  }
}

// 获取答题限制
export const useCommonGetSubmitCount = () => {
  const store = useStore()
  const isLimit = ref(true)
  const limtLoading = ref(true)
  const getLimitInfo = async (limit) => {
    if (!store.getters.getToken) {
      limtLoading.value = false
      return
    }
    limtLoading.value = true
    try {
      const res = await getSubmitCount({
        questionActiveKey: getQueryString('questionActiveKey'),
        isExercise: 1,
        token: store.getters.getToken,
      })
      // app内登陆后需要再请求一次
      if (limit) {
        limit.value = res?.ok
      }
      isLimit.value = res?.ok
      limtLoading.value = false
    } catch (e) {
      console.log('e', e)
      limtLoading.value = false
    }
  }

  onMounted(() => {
    getLimitInfo()
  })

  return {
    limtLoading,
    isLimit,
    getLimitInfo,
  }
}

// 处理填空题缓存的题
const handleFormatInputQues = (answerList, store) => {
  const newObj = {}
  answerList.map((item) => {
    // 报名的填空需要缓存，答题的填空不需要缓存，特殊处理一下
    if (item.questionType === 4) {
      if (store.getters.getQuesInfo.type !== 3) {
        newObj[item.questionKey] = [item.answers[0].answerContent]
      }
    }
    if (
      item.questionType === 11 ||
      item.questionType === 16 ||
      item.questionType === 25 ||
      item.questionType === 21
    ) {
      newObj[item.questionKey] = [item.answers[0].answerContent]
    }
  })

  const old = JSON.parse(JSON.stringify(store.getters.getInputCacheListObj))

  Object.keys(newObj).map((key) => {
    if (old[key]) {
      old[key] = Array.from(new Set([...old[key], ...newObj[key]]))
    } else {
      if (newObj[key]) {
        old[key] = newObj[key]
      }
    }
  })

  store.commit('setInputCacheListObj', {
    obj: old,
  })
}
